(() => {
  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const hideIfWholesale = (element) => {
    if (!(element instanceof HTMLElement)) return;

    const text = normalize(element.textContent);
    const ariaLabel = normalize(element.getAttribute('aria-label'));

    if (text === 'wholesale' || ariaLabel === 'wholesale') {
      element.hidden = true;
      element.style.setProperty('display', 'none', 'important');
      element.setAttribute('aria-hidden', 'true');
    }
  };

  const removeWholesaleBadges = (root = document) => {
    if (root instanceof HTMLElement) hideIfWholesale(root);

    root.querySelectorAll?.(
      '.badge, [class*="badge"], [class*="label"], [data-badge], [aria-label]'
    ).forEach(hideIfWholesale);
  };

  const addLogoutLink = (root = document) => {
    const drawerCandidates = root.querySelectorAll?.(
      'dialog, [role="dialog"], [class*="drawer"], [class*="account"], [class*="menu"]'
    ) || [];

    drawerCandidates.forEach((drawer) => {
      if (!(drawer instanceof HTMLElement)) return;
      if (drawer.querySelector('[data-amenity-logout]')) return;

      const text = normalize(drawer.textContent);
      const looksLikeAccountMenu =
        text.includes('your dashboard') &&
        text.includes('orders & shipments') &&
        text.includes('your profile');

      if (!looksLikeAccountMenu) return;

      const menuBox = Array.from(drawer.querySelectorAll('div, nav, ul')).find((element) => {
        const elementText = normalize(element.textContent);
        return elementText.includes('your dashboard') && elementText.includes('your profile');
      });

      if (!menuBox) return;

      const logout = document.createElement('a');
      logout.href = '/account/logout';
      logout.textContent = 'Log out';
      logout.setAttribute('data-amenity-logout', 'true');
      logout.style.display = 'block';
      logout.style.padding = '22px 28px';
      logout.style.borderTop = '1px solid rgba(0, 0, 0, 0.16)';
      logout.style.color = 'inherit';
      logout.style.font = 'inherit';
      logout.style.fontSize = 'inherit';
      logout.style.textDecoration = 'none';

      menuBox.appendChild(logout);
    });
  };

  const styleDashboardCards = (root = document) => {
    const pageText = normalize(document.body?.textContent);
    const isDashboard =
      pageText.includes('program level') &&
      pageText.includes('the stockroom') &&
      pageText.includes('your amenity editor');

    if (!isDashboard) return;

    const targets = ['program level', 'the stockroom', 'your amenity editor'];
    const candidates = root.querySelectorAll?.('h1, h2, h3, h4, h5, h6, p, span, a, div') || [];

    candidates.forEach((label) => {
      if (!(label instanceof HTMLElement)) return;
      const labelText = normalize(label.textContent);
      if (!targets.includes(labelText)) return;

      let card = label;
      let current = label.parentElement;

      while (current && current !== document.body) {
        const rect = current.getBoundingClientRect();
        const styles = window.getComputedStyle(current);
        const hasCardStyling =
          styles.backgroundColor !== 'rgba(0, 0, 0, 0)' ||
          styles.backgroundImage !== 'none' ||
          styles.boxShadow !== 'none' ||
          parseFloat(styles.borderWidth || '0') > 0;

        if (hasCardStyling && rect.width > 180 && rect.height > 80) {
          card = current;
          break;
        }

        current = current.parentElement;
      }

      if (!(card instanceof HTMLElement)) return;
      card.setAttribute('data-amenity-dashboard-card', 'true');
      card.style.setProperty('background', 'transparent', 'important');
      card.style.setProperty('background-color', 'transparent', 'important');
      card.style.setProperty('background-image', 'none', 'important');
      card.style.setProperty('box-shadow', 'none', 'important');
      card.style.setProperty('border', '1px solid rgba(0, 0, 0, 0.22)', 'important');
    });
  };

  const run = () => {
    removeWholesaleBadges(document);
    addLogoutLink(document);
    styleDashboardCards(document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        removeWholesaleBadges(node);
        addLogoutLink(node);
        styleDashboardCards(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
